// extracted by mini-css-extract-plugin
export default {"tooltipTrigger":"CalendarEvent_tooltipTrigger__hirHb","tooltip":"CalendarEvent_tooltip__eM1+E","bookingsPreview":"CalendarEvent_bookingsPreview__iSwMj"};